"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var createUser = function createUser(client) {
  return function (data) {
    return client.user.create(data);
  };
};
var _default = exports["default"] = createUser;
module.exports = exports["default"];